import axios from 'axios'
import Vue from 'vue'
import router from '../../router/index'
import { Loading } from 'element-ui';

let loadingInstance;
axios.defaults.baseURL = '/api/'
// 请求头拦截
axios.interceptors.request.use(config => {
    let token = window.sessionStorage.getItem('token');
    config.headers.ClientId = 'admin-app'
    if(token){
        config.headers.Authorization = token;
    }
    // 自定义不需要 loading 的
    if (config.headers.noLoading) {
        delete config.headers.noLoading
        return config
    }
    // NProgress.start();
    if(config.url != "system/message2/unReadCount"){
        loadingInstance = Loading.service({ fullscreen: true,background:"rgba(0, 0, 0, 0.8)",text:'加载中...'});
    }
    return config
})
/* 响应拦截器 */
axios.interceptors.response.use(function (response) {
    if (response.data.code === 401) {
        window.sessionStorage.removeItem('token');// 删除已经失效或过期的token
        router.replace({
            path: '/login' 
        })
    } 
    if(loadingInstance&& response.config.url!='system/message2/unReadCount'){
        loadingInstance.close();
    }
    return response
}, function (error) {
    loadingInstance && loadingInstance.close();
    return Promise.reject(error)
})
Vue.prototype.$http = axios;

export default axios;


